import React from 'react'

export default function Footer() {
  return (
    <footer className="content-footer footer bg-footer-theme">
          <div className="container-xxl">
            <div
              className="footer-container d-flex align-items-center justify-content-between py-2 flex-md-row flex-column"
            >
              <div>
                Copyright © 2025
                , made with ❤️ by <a href="https://saasaisolutions.com/" target="_blank" className="fw-semibold">SaaS AI Solutions</a>
              </div>
            </div>
          </div>
        </footer>
  )
}
